import React from "react";
import styles from "./MechatronikTypes.module.scss";

interface MechatronikTypesAccordionProps {
  title: string;
  content: string;
  isOpen: boolean;
  onToggle: () => void;
}

const MechatronikTypesAccordion: React.FC<MechatronikTypesAccordionProps> = ({
  title,
  content,
  isOpen,
  onToggle,
}) => {
  return (
    <div className={styles.accordionItem}>
      <div className={styles.accordionHeader} onClick={onToggle}>
        <h4>{title}</h4>
        <svg
          className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ""}`}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          aria-hidden="true"
        >
          <path
            fill="#888"
            fillRule="evenodd"
            d="M4.293 19.707a1 1 0 0 0 1.414 0l10-10a1 1 0 0 0-1.414-1.414l-10 10a1 1 0 0 0 0 1.414ZM18 6v13a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h13Z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      {isOpen && (
        <div
          className={styles.accordionBody}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  );
};

export default MechatronikTypesAccordion;
